export default () => '/fleet';
